<div class="adx-lib-panel-wrapper">
  <div class="adx-leaflet-panel-container">
    <h3>{{ 'MAP.ADD_MAP' | translate}}</h3>
    <div id="{{ 'map_widget_' + mapId }}" class="adx-osm-map-setting-widget"></div>
  </div>
</div>
